export default function useScrollToElement() {
  const scrollToElement = (elementId) => {
    const scrolledElem = document.getElementById(elementId);
    if (!scrolledElem) return;
    scrolledElem.scrollIntoView({
      block: "end",
      behavior: window?.isRNWebView ? "auto" : "smooth",
    });
  };

  return {
    scrollToElement,
  };
}
